import { Box, Toolbar, Tooltip, Typography, Autocomplete, TextField } from '@mui/material'
import Logo from '../../assets/logo.png';
import './Header.css';
import { useEffect, useState } from 'react';
import { useMsal } from "@azure/msal-react";
import { useLocation, useNavigate } from "react-router-dom";
import { getHeaderRoles } from '../../redux/actions/HeaderRoles/GetHeaderRolesSlice';
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { setProcurementDivisionType } from '../../redux/actions/userTypeSlice';
import { getProcurementDivisionType } from '../../utils/procurementDivision';

const Header = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { storedRoles, headerRef } = props;
  const tabDetails = useSelector((state) => state?.dashboardDetails?.tabDetails);
  const { accounts } = useMsal();
  const cardTitle = localStorage.getItem("cardTitle");

  const [LTPlantOptions, setLTPlantOptions] = useState(
    () => {
      const storedData = localStorage.getItem("LTPlantOptions");
      return storedData ? JSON.parse(storedData) : [];
    }
  );
  const [CDPlantOptions, setCDPlantOptions] = useState(
    () => {
      const storedData = localStorage.getItem("CDPlantOptions");
      return storedData ? JSON.parse(storedData) : [];
    }
  );
  const [LTRegionOptions, setLTRegionOptions] = useState(
    () => {
      const storedData = localStorage.getItem("LTRegionOptions");
      return storedData ? JSON.parse(storedData) : [];
    }
  );
  const [CDRegionOptions, setCDRegionOptions] = useState(
    () => {
      const storedData = localStorage.getItem("CDRegionOptions");
      return storedData ? JSON.parse(storedData) : [];
    }
  );
  const [APIResponse, setAPIResponse] = useState(
    () => {
      const storedData = localStorage.getItem("roleAPIResp");
      return storedData ? JSON.parse(storedData) : [];
    }
  )
  const [selectedLTPlant, setSelectedLTPlant] = useState(localStorage.getItem("selectedLTPlant"));
  const [selectedLTRole, setSelectedLTRole] = useState(localStorage.getItem("LTRole"))
  const [selectedCDPlant, setSelectedCDPlant] = useState(localStorage.getItem("selectedCDPlant"));
  const [selectedCDRole, setSelectedCDRole] = useState(localStorage.getItem("CDRole"));
  const [selectedLTRegion, setSelectedLTRegion] = useState(localStorage.getItem("LTRegion"));
  const [selectedCDRegion, setSelectedCDRegion] = useState(localStorage.getItem("CDRegion"));


  const handleRegionChange = (event, cardTitle) => {
    localStorage.removeItem("savedVariantFilterModel");
    localStorage.setItem("activeCard", 0);
    localStorage.setItem("approverActiveItem", "Pending Approval");
    localStorage.setItem("workflowActiveItem", "Pending Action");
    localStorage.setItem("lastVisitedPage", 0);
    localStorage.setItem("reportsActiveItem", "Lead Time Variations at Component Level");

    if (cardTitle === "LT") {
      setSelectedLTRegion(event.target.value);
      localStorage.setItem("LTRegion", event.target.value);
      const ltPlantOptionsResp = APIResponse?.LT?.filter(region => region?.cokeRegion === event.target.value);
      setLTPlantOptions(ltPlantOptionsResp);
      setSelectedLTPlant(ltPlantOptionsResp?.[0]?.plant);
      setSelectedLTRole(ltPlantOptionsResp?.[0]?.roles?.[0]);
      const LTData = JSON.stringify(ltPlantOptionsResp);
      localStorage.setItem("LTPlantOptions", LTData);
      localStorage.setItem("selectedLTPlant", ltPlantOptionsResp?.[0]?.plant);
      localStorage.setItem("selectedLTPlantCode", ltPlantOptionsResp?.[0]?.plant);
      localStorage.setItem("LTRole", ltPlantOptionsResp?.[0]?.roles?.[0]);
      localStorage.setItem("LTplantType", ltPlantOptionsResp?.[0]?.plantType);

      const defaultRoleLT = ltPlantOptionsResp?.[0]?.roles?.[0]

      if (defaultRoleLT === "Planner" && ltPlantOptionsResp?.[0]?.plantType === "CPS") {
        window.location.href = '/lt-dashboard'
      }
      if (defaultRoleLT === "Admin" && ltPlantOptionsResp?.[0]?.plantType === "CPS") {
        window.location.href = '/run-analytics-scheduler'
      }
      if (defaultRoleLT === "Approver" && ltPlantOptionsResp?.[0]?.plantType === "CPS") {
        window.location.href = '/approval-management'
      }
      if (defaultRoleLT === "Planner" && ltPlantOptionsResp?.[0]?.plantType === "DPS") {
        window.location.href = '/DPS-Planner-analytics'
      }
      if (defaultRoleLT === "Viewer" && ltPlantOptionsResp?.[0]?.plantType === "CPS") {
        window.location.href = '/viewer-analytics-results'
      }
      if (defaultRoleLT === "GMP" && ltPlantOptionsResp?.[0]?.plantType === "CPS") {
        window.location.href = '/gmp-dashboard'
      }
      localStorage.setItem("LTPathName", (defaultRoleLT === "Planner" && ltPlantOptionsResp?.[0]?.plantType === "CPS") ? "/lt-dashboard" : (defaultRoleLT === "Admin" && ltPlantOptionsResp?.[0]?.plantType === "CPS") ? "/run-analytics-scheduler" : (defaultRoleLT === "Approver" && ltPlantOptionsResp?.[0]?.plantType === "CPS") ? "/approval-management" : (defaultRoleLT === "Planner" && ltPlantOptionsResp?.[0]?.plantType === "DPS") ? "/DPS-Planner-analytics" : (defaultRoleLT === "Viewer" && ltPlantOptionsResp?.[0]?.plantType === "CPS") ? "/viewer-analytics-results" : (defaultRoleLT === "GMP" && ltPlantOptionsResp?.[0]?.plantType === "CPS") ? "/gmp-dashboard" : "");

    }

    if (cardTitle === "CD") {
      setSelectedCDRegion(event.target.value);
      localStorage.setItem("CDRegion", event.target.value);
      const cdPlantOptionsResp = APIResponse?.CD?.filter(region => region?.cokeRegion === event.target.value);
      setCDPlantOptions(cdPlantOptionsResp);
      setSelectedCDPlant(cdPlantOptionsResp?.[0]?.plant);
      setSelectedCDRole(cdPlantOptionsResp?.[0]?.roles?.[0]);
      const CDData = JSON.stringify(cdPlantOptionsResp);
      localStorage.setItem("CDPlantOptions", CDData);
      localStorage.setItem("selectedCDPlant", cdPlantOptionsResp?.[0]?.plant);
      localStorage.setItem("selectedCDPlantCode", cdPlantOptionsResp?.[0]?.plant);
      localStorage.setItem("CDRole", cdPlantOptionsResp?.[0]?.roles?.[0]);
      localStorage.setItem("CDplantType", cdPlantOptionsResp?.[0]?.plantType);

      const defaultRoleCD = cdPlantOptionsResp?.[0]?.roles?.[0]

      if (defaultRoleCD === "Planner") {
        window.location.href = '/cd-dashboard'
      }
      if (defaultRoleCD === "Admin") {
        window.location.href = '/cd-dashboard'
      }
      if (defaultRoleCD === "Approver") {
        window.location.href = '/cd-dashboard'
      }
      if (defaultRoleCD === "Viewer") {
        window.location.href = '/cd-dashboard'
      }
      if (defaultRoleCD === "GMP") {
        window.location.href = '/price-memo'
      }
      if (defaultRoleCD === "Analyst") {
        window.location.href = '/cd-dashboard'
      }
      if (defaultRoleCD === "MOP") {
        window.location.href = '/cd-dashboard'
      }
      if (defaultRoleCD === "Price Memo Owner (Packaging)") {
        window.location.href = '/pricememo-management'
      }
      if (defaultRoleCD === "Price Memo Viewer (Packaging)") {
        window.location.href = '/packaging-viewer-pricememo'
      }
      if (defaultRoleCD === "Price Memo Owner (CEPG)") {
        window.location.href = '/pricememo-management'
      }
      if (defaultRoleCD === "Price Memo Viewer (CEPG)") {
        window.location.href = '/packaging-viewer-pricememo'
      }
      localStorage.setItem("CDPathName", defaultRoleCD === "Planner" ? "/cd-dashboard" : defaultRoleCD === "Admin" ? "/cd-dashboard" : defaultRoleCD === "Approver" ? "/cd-dashboard" : defaultRoleCD === "Viewer" ? "/cd-dashboard" : defaultRoleCD === "GMP" ? "/price-memo" : defaultRoleCD === "Analyst" ? "/cd-dashboard" : defaultRoleCD === "MOP" ? "/cd-dashboard" : defaultRoleCD === "Price Memo Owner (Packaging)" ? "/pricememo-management" : defaultRoleCD === "Price Memo Viewer (Packaging)" ? "/packaging-viewer-pricememo" : defaultRoleCD === "Price Memo Owner (CEPG)" ? "/pricememo-management" : defaultRoleCD === "Price Memo Viewer (CEPG)" ? "/packaging-viewer-pricememo" : "");
    }
  }

  const handleChange = (event, cardTitle) => {
    localStorage.removeItem("savedVariantFilterModel");
    const newPlant = cardTitle === "LT" ? LTPlantOptions?.find((p) => p.plant === event.target.value) : CDPlantOptions?.find((p) => p.plant === event.target.value)
    localStorage.setItem("activeCard", 0);
    localStorage.setItem("approverActiveItem", "Pending Approval");
    localStorage.setItem("workflowActiveItem", "Pending Action");
    localStorage.setItem("lastVisitedPage", 0);
    localStorage.setItem("reportsActiveItem", "Lead Time Variations at Component Level");

    if (newPlant) {

      const defaultRole = newPlant.roles[0];

      if (cardTitle === "LT") {
        setSelectedLTPlant(newPlant.plant);
        setSelectedLTRole(defaultRole);
        localStorage.setItem("selectedLTPlant", newPlant.plant);
        localStorage.setItem("selectedLTPlantCode", newPlant?.plant);
        localStorage.setItem("LTRole", defaultRole);
        localStorage.setItem("LTplantType", newPlant?.plantType);

        if (defaultRole === "Planner" && newPlant?.plantType === "CPS") {
          window.location.href = '/lt-dashboard'
        }
        if (defaultRole === "Admin" && newPlant?.plantType === "CPS") {
          window.location.href = '/run-analytics-scheduler'
        }
        if (defaultRole === "Approver" && newPlant?.plantType === "CPS") {
          window.location.href = '/approval-management'
        }
        if (defaultRole === "Planner" && newPlant?.plantType === "DPS") {
          window.location.href = '/DPS-Planner-analytics'
        }
        if (defaultRole === "Viewer" && newPlant?.plantType === "CPS") {
          window.location.href = '/viewer-analytics-results'
        }
        if (defaultRole === "GMP" && newPlant?.plantType === "CPS") {
          window.location.href = '/gmp-dashboard'
        }
        localStorage.setItem("LTPathName", (defaultRole === "Planner" && newPlant?.plantType === "CPS") ? "/lt-dashboard" : (defaultRole === "Admin" && newPlant?.plantType === "CPS") ? "/run-analytics-scheduler" : (defaultRole === "Approver" && newPlant?.plantType === "CPS") ? "/approval-management" : (defaultRole === "Planner" && newPlant?.plantType === "DPS") ? "/DPS-Planner-analytics" : (defaultRole === "Viewer" && newPlant?.plantType === "CPS") ? "/viewer-analytics-results" : (defaultRole === "GMP" && newPlant?.plantType === "CPS") ? "/gmp-dashboard" : "");
      }
      if (cardTitle === "CD") {
        setSelectedCDPlant(newPlant.plant);
        setSelectedCDRole(defaultRole);
        localStorage.setItem("selectedCDPlant", newPlant.plant);
        localStorage.setItem("selectedCDPlantCode", newPlant?.plant);
        localStorage.setItem("CDRole", defaultRole);
        localStorage.setItem("CDplantType", newPlant?.plantType);

        if (defaultRole === "Planner") {
          window.location.href = '/cd-dashboard'
        }
        if (defaultRole === "Admin") {
          window.location.href = '/cd-dashboard'
        }
        if (defaultRole === "Approver") {
          window.location.href = '/cd-dashboard'
        }
        if (defaultRole === "Viewer") {
          window.location.href = '/cd-dashboard'
        }
        if (defaultRole === "GMP") {
          window.location.href = '/cd-dashboard'
        }
        if (defaultRole === "Analyst") {
          window.location.href = '/cd-dashboard'
        }
        if (defaultRole === "MOP") {
          window.location.href = '/cd-dashboard'
        }
        if (defaultRole === "Price Memo Owner (Packaging)") {
          window.location.href = '/pricememo-management'
        }
        if (defaultRole === "Price Memo Viewer (Packaging)") {
          window.location.href = '/packaging-viewer-pricememo'
        }
        if (defaultRole === "Price Memo Owner (CEPG)") {
          window.location.href = '/pricememo-management'
        }
        if (defaultRole === "Price Memo Viewer (CEPG)") {
          window.location.href = '/packaging-viewer-pricememo'
        }
        localStorage.setItem("CDPathName", defaultRole === "Planner" ? "/cd-dashboard" : defaultRole === "Admin" ? "/cd-dashboard" : defaultRole === "Approver" ? "/cd-dashboard" : defaultRole === "Viewer" ? "/cd-dashboard" : defaultRole === "GMP" ? "/cd-dashboard" : defaultRole === "Analyst" ? "/cd-dashboard" : defaultRole === "MOP" ? "/cd-dashboard" : defaultRole === "Price Memo Owner (Packaging)" ? "/pricememo-management" : defaultRole === "Price Memo Viewer (Packaging)" ? "/packaging-viewer-pricememo" : defaultRole === "Price Memo Owner (CEPG)" ? "/pricememo-management" : defaultRole === "Price Memo Viewer (CEPG)" ? "/packaging-viewer-pricememo" : "");
      }
    }

  };
  const handleRoleChange = (event) => {
    localStorage.removeItem("savedVariantFilterModel");
    const plantType = localStorage.getItem("LTplantType");
    localStorage.setItem("activeCard", 0);
    localStorage.setItem("approverActiveItem", "Pending Approval");
    localStorage.setItem("workflowActiveItem", "Pending Action");
    localStorage.setItem("lastVisitedPage", 0);
    localStorage.setItem("reportsActiveItem", "Lead Time Variations at Component Level");

    if (cardTitle === "Lead Time Analytics") {
      setSelectedLTRole(event.target.value);
      localStorage.setItem("LTRole", event.target.value);
      if (event.target.value === "Planner" && plantType === "CPS") {
        navigate('/lt-dashboard');
      }
      if (event.target.value === "Admin" && plantType === "CPS") {
        navigate('/run-analytics-scheduler');
      }
      if (event.target.value === "Approver" && plantType === "CPS") {
        navigate('/approval-management');
      }
      if (event.target.value === "Planner" && plantType === "DPS") {
        navigate('/DPS-Planner-analytics');
      }
      if (event.target.value === "Viewer" && plantType === "CPS") {
        navigate('/viewer-analytics-results');
      }
      if (event.target.value === "GMP" && plantType === "CPS") {
        navigate('/gmp-dashboard');
      }
      localStorage.setItem("LTPathName", (event.target.value === "Planner" && plantType === "CPS") ? "/lt-dashboard" : (event.target.value === "Admin" && plantType === "CPS") ? "/run-analytics-scheduler" : (event.target.value === "Approver" && plantType === "CPS") ? "/approval-management" : (event.target.value === "Planner" && plantType === "DPS") ? "/DPS-Planner-analytics" : (event.target.value === "Viewer" && plantType === "CPS") ? "/viewer-analytics-results" : (event.target.value === "GMP" && plantType === "CPS") ? "/gmp-dashboard" : "");
    }
    if (cardTitle === "Contract Data Update") {
      const nextDivisionType = getProcurementDivisionType(event.target.value);

      setSelectedCDRole(event.target.value);
      localStorage.setItem("CDRole", event.target.value);
      localStorage.setItem("procurementDivisionType", nextDivisionType);
      dispatch(setProcurementDivisionType(nextDivisionType));

      if (event.target.value === "Planner") {
        navigate('/cd-dashboard');
      }
      if (event.target.value === "Admin") {
        navigate('/cd-dashboard')
      }
      if (event.target.value === "Approver") {
        navigate('/cd-dashboard')
      }
      if (event.target.value === "Viewer") {
        navigate('/cd-dashboard')
      }
      if (event.target.value === "GMP") {
        navigate('/cd-dashboard')
      }
      if (event.target.value === "Analyst") {
        navigate('/cd-dashboard')
      }
      if (event.target.value === "MOP") {
        navigate('/cd-dashboard')
      }
      if (event.target.value === "Price Memo Owner (Packaging)") {
        navigate('/pricememo-management')
      }
      if (event.target.value === "Price Memo Viewer (Packaging)") {
        navigate('/packaging-viewer-pricememo')
      }
      if (event.target.value === "Price Memo Owner (CEPG)") {
        navigate('/pricememo-management')
      }
      if (event.target.value === "Price Memo Viewer (CEPG)") {
        navigate('/packaging-viewer-pricememo')
      }
      localStorage.setItem("CDPathName", event.target.value === "Planner" ? "/cd-dashboard" : event.target.value === "Admin" ? "/cd-dashboard" : event.target.value === "Approver" ? "/cd-dashboard" : event.target.value === "Viewer" ? "/cd-dashboard" : event.target.value === "GMP" ? "/cd-dashboard" : event.target.value === "Analyst" ? "/cd-dashboard" : event.target.value === "MOP" ? "/cd-dashboard" : event.target.value === "Price Memo Owner (Packaging)" ? "/pricememo-management" : event.target.value === "Price Memo Viewer (Packaging)" ? "/packaging-viewer-pricememo" : event.target.value === "Price Memo Owner (CEPG)" ? "/pricememo-management" : event.target.value === "Price Memo Viewer (CEPG)" ? "/packaging-viewer-pricememo" : "");
    }
  };

  useEffect(() => {
    const getHeaderRolesData = async () => {

      try {
        const responseHeaderRoles = await dispatch(getHeaderRoles({
          dynamicEndpoint: 'api/user/fetch-user-details',
        }));
        if (responseHeaderRoles?.meta?.requestStatus === 'fulfilled') {
          const plantsData = responseHeaderRoles?.payload?.userRoles;
          setAPIResponse(plantsData)
          const roleAPIResp = JSON.stringify(plantsData);
          localStorage.setItem("roleAPIResp", roleAPIResp)

          if (plantsData) {

            const defaultLTRegion = plantsData?.LTRegions[0];
            const ltRegionObj = plantsData?.LT?.filter(item => item?.cokeRegion === defaultLTRegion);

            const defaultCDRegion = plantsData?.CDRegions[0];
            const cdRegionObj = plantsData?.CD?.filter(item => item?.cokeRegion === defaultCDRegion);

            storedRoles({
              selectedLTRole: ltRegionObj?.[0]?.roles[0],
              selectedCDRole: cdRegionObj?.[0]?.roles[0]
            })

            setLTRegionOptions(plantsData?.LTRegions);
            setSelectedLTRegion(defaultLTRegion);
            localStorage.setItem("LTRegion", defaultLTRegion);
            const LTRegionData = JSON.stringify(plantsData?.LTRegions);
            localStorage.setItem("LTRegionOptions", LTRegionData);
            if (ltRegionObj?.length > 0) {
              setLTPlantOptions(ltRegionObj)
              setSelectedLTPlant(ltRegionObj?.[0]?.plant)
              setSelectedLTRole(ltRegionObj?.[0]?.roles[0]);

              const ltData = JSON.stringify(ltRegionObj);

              localStorage.setItem("LTPlantOptions", ltData);
              localStorage.setItem("selectedLTPlant", ltRegionObj?.[0]?.plant);
              localStorage.setItem("selectedLTPlantCode", ltRegionObj?.[0]?.plant);
              localStorage.setItem("LTplantType", ltRegionObj?.[0]?.plantType);
              localStorage.setItem("LTRole", ltRegionObj?.[0]?.roles[0]);
              localStorage.setItem("LTPathName", (ltRegionObj?.[0]?.roles[0] === "Planner" && ltRegionObj?.[0]?.plantType === "CPS") ? "/lt-dashboard" : (ltRegionObj?.[0]?.roles[0] === "Admin" && ltRegionObj?.[0]?.plantType === "CPS") ? "/run-analytics-scheduler" : (ltRegionObj?.[0]?.roles[0] === "Approver" && ltRegionObj?.[0]?.plantType === "CPS") ? "/approval-management" : (ltRegionObj?.[0]?.roles[0] === "Planner" && ltRegionObj?.[0]?.plantType === "DPS") ? "/DPS-Planner-analytics" : (ltRegionObj?.[0]?.roles[0] === "Viewer" && ltRegionObj?.[0]?.plantType === "CPS") ? "/viewer-analytics-results" : (ltRegionObj?.[0]?.roles[0] === "GMP" && ltRegionObj?.[0]?.plantType === "CPS") ?
                "/gmp-dashboard" : "");

            }
            setCDRegionOptions(plantsData?.CDRegions);
            setSelectedCDRegion(defaultCDRegion);
            localStorage.setItem("CDRegion", defaultCDRegion);
            const CDRegionData = JSON.stringify(plantsData?.CDRegions);
            localStorage.setItem("CDRegionOptions", CDRegionData);
            if (cdRegionObj?.length > 0) {
              setCDPlantOptions(cdRegionObj)
              setSelectedCDPlant(cdRegionObj?.[0]?.plant)
              setSelectedCDRole(cdRegionObj?.[0]?.roles[0])

              const CDData = JSON.stringify(cdRegionObj);
              localStorage.setItem("CDPlantOptions", CDData);
              localStorage.setItem("selectedCDPlant", cdRegionObj?.[0]?.plant);
              localStorage.setItem("selectedCDPlantCode", cdRegionObj?.[0]?.plant);
              localStorage.setItem("CDplantType", cdRegionObj?.[0]?.plantType)
              localStorage.setItem("CDRole", cdRegionObj?.[0]?.roles[0])
              localStorage.setItem("procurementDivisionType", getProcurementDivisionType(cdRegionObj?.[0]?.roles[0]));
              dispatch(setProcurementDivisionType(getProcurementDivisionType(cdRegionObj?.[0]?.roles[0])));
              localStorage.setItem("CDPathName", cdRegionObj?.[0]?.roles[0] === "Planner" ? "/cd-dashboard" : cdRegionObj?.[0]?.roles[0] === "Admin" ? "/cd-dashboard" : cdRegionObj?.[0]?.roles[0] === "Approver" ? "/cd-dashboard" : cdRegionObj?.[0]?.roles[0] === "Viewer" ? "/cd-dashboard" : cdRegionObj?.[0]?.roles[0] === "GMP" ? "/cd-dashboard" : cdRegionObj?.[0]?.roles[0] === "Analyst" ? "/cd-dashboard" : cdRegionObj?.[0]?.roles[0] === "MOP" ? "/cd-dashboard" : cdRegionObj?.[0]?.roles[0] === "Price Memo Owner (Packaging)" ? "/pricememo-management" : cdRegionObj?.[0]?.roles[0] === "Price Memo Viewer (Packaging)" ? "/packaging-viewer-pricememo" : cdRegionObj?.[0]?.roles[0] === "Price Memo Owner (CEPG)" ? "/pricememo-management" : cdRegionObj?.[0]?.roles[0] === "Price Memo Viewer (CEPG)" ? "/packaging-viewer-pricememo" : "");
            }
          }
        } else {
          toast.error(responseHeaderRoles?.payload?.errorMessage, {
            autoClose: 2000,
          });
        }
      } catch (error) {
        console.error('API error:', error);
      }
    }
    if (tabDetails?.title === "Landing") {
      const LTRole = localStorage.getItem("LTRole");
      const CDRole = localStorage.getItem("CDRole");

      if (LTRole && CDRole) {
        console.log("Roles are available");
      }
      else {
        getHeaderRolesData();
      }
    }

  }, [cardTitle, dispatch, tabDetails]);

  return (
    <div className="main-header" ref={headerRef}>
      <Toolbar className='toolbar_header'>
        <div className="main-box">
          <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
            <img src={Logo} alt="logo" width={64} height={20} />
            <h3>Technical, Innovation & Supply Chain</h3>
          </div>
          <Box sx={{ flexGrow: 0 }}>
            <Tooltip>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ textAlign: 'right' }}>
                  <Typography sx={{ mr: 1, fontSize: '13px' }} >{accounts[0]?.name}</Typography>
                 {location?.pathname !== "/landing-page" && location?.pathname !== "/quota-maintenance"&& location?.pathname !== "/quota-maintenance/results" && location?.pathname?.length > 3 && cardTitle &&
                    <div >
                      <div>
                        {cardTitle === "Lead Time Analytics" ?
                          <div style={{ display: 'flex', gap: 10, fontSize: 14, marginTop: 8 }}>
                            {/* <div>
                              <span>Region : </span>
                              <Select
                                labelId="demo-select-small-label"
                                id="demo-select-small"
                                value={selectedLTRegion}
                                onChange={(e) => handleRegionChange(e, "LT")}
                                // sx={{ minWidth: 80, backgroundColor: "#fff", border: '1px solid #000', height: 20 }}
                                sx={{
                                  width: 100, // Fixed width
                                  backgroundColor: "#fff",
                                  border: '1px solid #000',
                                  height: 20,
                                  overflow: "hidden",
                                  whiteSpace: "nowrap",
                                  textOverflow: "ellipsis",
                                  textAlign: 'center'
                                }}
                                MenuProps={{
                                  PaperProps: {
                                    style: {
                                      maxHeight: 200, // You can adjust this value as needed
                                      overflowY: 'auto'
                                    }
                                  }
                                }}
                              >
                                {LTRegionOptions?.map((item, index) => {
                                  return <MenuItem key={index} value={item}>{item}</MenuItem>
                                })}

                              </Select>
                            </div> */}
                            <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
                              <span>Region : </span>
                              <Autocomplete
                                disableClearable={true}
                                options={LTRegionOptions}
                                value={selectedLTRegion || null}
                                onChange={(event, newValue) => {
                                  if (newValue) {
                                    handleRegionChange({ target: { value: newValue } }, "LT");
                                  }
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    InputProps={{
                                      ...params.InputProps,
                                      sx: {
                                        width: 130,
                                        backgroundColor: "#fff",
                                        overflow: "hidden",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                      }
                                    }}
                                  />
                                )}
                                sx={{
                                  width: 130,
                                  "& .MuiInputBase-root": {
                                    height: 20,
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                  },
                                }}
                              />
                            </div>
                            <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
                              <span>Plant : </span>
                              <Autocomplete
                                disableClearable={true}
                                options={LTPlantOptions}
                                getOptionLabel={(option) => `${option.plant} - ${option.plantName}`}
                                value={LTPlantOptions.find(item => item.plant === selectedLTPlant) || null}
                                onChange={(event, newValue) => {
                                  if (newValue) {
                                    handleChange({ target: { value: newValue.plant } }, "LT");
                                  }
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    InputProps={{
                                      ...params.InputProps,
                                      sx: {
                                        width: 150,
                                        backgroundColor: "#fff",
                                        overflow: "hidden",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                      }
                                    }}
                                  />
                                )}
                                sx={{
                                  width: 150,
                                  "& .MuiInputBase-root": {
                                    height: 20,
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                  },
                                }}
                              />
                            </div>
                            <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
                              <span>Role : </span>
                              <Autocomplete
                                disableClearable={true}
                                value={selectedLTRole}
                                onChange={(event, newValue) => {
                                  handleRoleChange({ target: { value: newValue } });
                                }}
                                options={LTPlantOptions?.find(p => p.plant === selectedLTPlant)?.roles || []}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    InputProps={{
                                      ...params.InputProps,
                                      sx: {
                                        width: 100,
                                        backgroundColor: "#fff",
                                        overflow: "hidden",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                      }
                                    }}
                                  />
                                )}
                                sx={{
                                  width: 100,
                                  "& .MuiInputBase-root": {
                                    height: 20,
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                  }
                                }}
                              />
                            </div>
                          </div>
                          :
                          cardTitle === "Contract Data Update" &&
                            location?.pathname !== "/contract-maintenance" &&
                            location?.pathname !== "/cm-reports" &&
                            location?.pathname !== "/contract-maintenance/new-contract" &&
                            location?.pathname !== "/contract-maintenance/update-contract" &&
                            location?.pathname !== "/contract-maintenance/review-auto-target-value" ?
                            <div style={{ display: 'flex', gap: 10, fontSize: 14, marginTop: 8 }}>
                              <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
                                <span>Region : </span>
                                <Autocomplete
                                  disableClearable={true}
                                  options={CDRegionOptions}
                                  value={selectedCDRegion || null}
                                  onChange={(event, newValue) => {
                                    if (newValue) {
                                      handleRegionChange({ target: { value: newValue } }, "CD");
                                    }
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant="outlined"
                                      InputProps={{
                                        ...params.InputProps,
                                        sx: {
                                          width: 130,
                                          backgroundColor: "#fff",
                                          overflow: "hidden",
                                          whiteSpace: "nowrap",
                                          textOverflow: "ellipsis",
                                        }
                                      }}
                                    />
                                  )}
                                  sx={{
                                    width: 130,
                                    "& .MuiInputBase-root": {
                                      height: 20,
                                      overflow: "hidden",
                                      whiteSpace: "nowrap",
                                      textOverflow: "ellipsis",
                                    },
                                  }}
                                />
                              </div>
                              <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
                                <span>Plant : </span>
                                <Autocomplete
                                  disableClearable={true}
                                  options={CDPlantOptions}
                                  getOptionLabel={(option) => `${option.plant} - ${option.plantName}`}
                                  value={CDPlantOptions.find(item => item.plant === selectedCDPlant) || null}
                                  onChange={(event, newValue) => {
                                    if (newValue) {
                                      handleChange({ target: { value: newValue.plant } }, "CD");
                                    }
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant="outlined"
                                      InputProps={{
                                        ...params.InputProps,
                                        sx: {
                                          width: 150,
                                          backgroundColor: "#fff",
                                          overflow: "hidden",
                                          whiteSpace: "nowrap",
                                          textOverflow: "ellipsis",
                                        }
                                      }}
                                    />
                                  )}
                                  sx={{
                                    width: 150,
                                    "& .MuiInputBase-root": {
                                      height: 20,
                                      overflow: "hidden",
                                      whiteSpace: "nowrap",
                                      textOverflow: "ellipsis",
                                    },
                                  }}
                                />
                              </div>
                              <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
                                <span>Role : </span>
                                <Autocomplete
                                  disableClearable={true}
                                  value={selectedCDRole}
                                  onChange={(event, newValue) => {
                                    handleRoleChange({ target: { value: newValue } });
                                  }}
                                  options={CDPlantOptions?.find(p => p.plant === selectedCDPlant)?.roles || []}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant="outlined"
                                      InputProps={{
                                        ...params.InputProps,
                                        sx: {
                                          width: 260,
                                          backgroundColor: "#fff",
                                          overflow: "hidden",
                                          whiteSpace: "nowrap",
                                          textOverflow: "ellipsis",
                                        }
                                      }}
                                    />
                                  )}
                                  sx={{
                                    width: 260,
                                    "& .MuiInputBase-root": {
                                      height: 20,
                                      overflow: "hidden",
                                      whiteSpace: "nowrap",
                                      textOverflow: "ellipsis",
                                    }
                                  }}
                                />
                              </div>
                            </div> :
                            <div></div>}
                      </div>
                    </div>}
                </Box>

                <div>
                  <button onClick={props.handleLogout} className='logoutCustomButton'>Log Out</button>
                </div>
              </Box>
            </Tooltip>
          </Box>
        </div>
      </Toolbar>
      <div className='gradient_section'>
        <span style={{ display: 'flex', justifyContent: 'center' }}>
          {process.env.REACT_APP_ENV === "dev" ?
            "Development Environment - This is not Production. Use only for testing & development"
            : process.env.REACT_APP_ENV === "test" ?
              "UAT Environment - This is not Production. Use only for user acceptance testing"
              : process.env.REACT_APP_ENV === "uat" ?
                "UAT Environment - This is not Production. Use only for user acceptance testing"
                : process.env.REACT_APP_ENV === "prod" ?
                  ""
                  : ""}
        </span>
      </div>
    </div>
  );
}

export default Header